
import $ from 'jquery';
import Vue from 'vue';
import FileUpload from '../components/FileUpload'
import moment from 'moment'
import numFormat from 'vue-filter-number-format'
import PayinItem from '../components/Payin/PayinItem';
import PayinEdit from '../components/Payin/PayinEdit';
import PayinCreate from '../components/Payin/PayinCreate';
Vue.filter('numFormat', numFormat);

moment.locale('en');

if($('#vue-wow-form-payin').length){
    window.WowFormPassenger = new Vue({
        el: '#vue-wow-form-payin',
        components: { 
            PayinItem,
            PayinCreate,
            PayinEdit,
            FileUpload,
        },
        data: {
            loading: false,
            payments: [],
            paxAmount: 0,
            bookingDetail: {},
            totalPayment: 0,
            deposit: 0,
            remainPayment: 0,
            totalComagent: 0,
        },
        computed:{
            bookingStatus(){
                let bookingStatus = this.bookingDetail && this.bookingDetail.booking_status ? this.bookingDetail.booking_status : ''
                return bookingStatus
            }
        },
        watch: {
            payments: function (newPayments) {
                this.totalComagent = this.bookingDetail.comagent * this.paxAmount
                this.totalComsale = this.bookingDetail.comsale * this.paxAmount
                this.totalPayment = newPayments.reduce( (totalPayment, payment) => totalPayment + payment.payment_price, 0)
                this.remainPayment = this.bookingDetail.booking_totalprice - this.totalPayment - this.totalComagent - this.totalComsale
            }
        },
        created(){
            this.bookingDetail = window.TX_PAYIN_BOOKING_DATA
            this.paxAmount = this.bookingDetail.adults_double + 
            this.bookingDetail.adults_single +
            this.bookingDetail.adults_triple +
            this.bookingDetail.child_nobed +
            this.bookingDetail.child_withbed
            this.fetchData();
        },
        methods: {
            fetchData(){
                if( this.bookingDetail && this.bookingDetail.pnrcode ){
                    return new Promise((resolve, reject)=>{
                        this.loading = true
                        $.get(window.AJAX_URL, {
                            dataType: 'json',
                            _wpnonce: AJAX_NONCE,
                            action: 'get_payment',
                            pnrcode: this.bookingDetail.pnrcode,
                            email: this.bookingDetail.email_contact,
                        })
                        .done( data => {
                            let payments = [];
                            if( data.success == true && data.payments ){
                                payments = data.payments.map( payment => {
                                    return {
                                        ...payment,
                                        payment_pay_date_display: payment.payment_pay_date,
                                        isEdit: false
                                    }
                                })
                            }
                            this.payments = payments
                            this.loading = false
                            resolve(payments);
                        })
                        .fail( data => {
                            this.loading = false
                            resolve([]);
                        });
                    })
                }
            },
            handleDeletePayment(paymentId) {
                UIkit.modal.confirm('ยืนยันการลบ Pay-in').then(() => {
                    this.doDeletePayin(paymentId)
                    this.payments = this.payments.filter( payment => {
                        return !(payment.payment_paidbyid == paymentId)
                    } )
                }, () => {});
            },
            handleCreatePayment(payment) {
                return new Promise((resolve, reject)=>{
                    
                    const formData = new FormData();
                    formData.append('action', 'save_payin' );
                    formData.append('_wpnonce', AJAX_NONCE );

                    if( payment.image_file !== null && payment.image_file && payment.image_file.name ){
                        formData.append( 'file' , payment.image_file, payment.image_file.name );
                    }
                    formData.append('pnrcode', this.bookingDetail.pnrcode )
                    formData.append('paidbyid', payment.paidbyid )
                    formData.append('paid_amount', payment.paid_amount )
                    formData.append('paid_date', payment.paid_date )
                    formData.append('paid_time', payment.paid_time )
                    formData.append('remark', payment.remark )

                    $.ajax({
                        type: "POST",
                        url: window.AJAX_URL,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        data: formData,
                        success: (data) => {
                            if( data && data.success === true ){
                                alert('บันทึกข้อมูลสำเร็จ');
                                this.fetchData()
                                this.syncBookingDetailData()
                                resolve({
                                    success: true
                                })
                            }else{
                                const errorMessage = data && data.message ? data.message : 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ'
                                alert(errorMessage);
                                resolve({
                                    success: false
                                })
                            }
                        },
                        error: (data) => {
                            alert('บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ');
                            resolve({
                                success: false
                            })
                        }
                    })
                })
            },
            handleEditPayment(paymentId) {
                this.payments = this.payments.map( payment => {
                    if (payment.payment_paidbyid == paymentId) {
                        payment.isEdit = true
                    }else{
                        payment.isEdit = false
                    }
                    return payment;
                } )
            },
            handleUpdatePayment(payment) {
               return new Promise((resolve, reject)=>{
                const formData = new FormData();
                    formData.append('action', 'update_payin' );
                    formData.append('_wpnonce', AJAX_NONCE );

                    if( payment.image_file !== null && payment.image_file && payment.image_file.name ){
                        formData.append( 'file' , payment.image_file, payment.image_file.name );
                    }
                    formData.append('pnrcode', this.bookingDetail.pnrcode )
                    formData.append('paidbyid', payment.paidbyid )
                    formData.append('paid_amount', payment.paid_amount )
                    formData.append('paid_date', payment.paid_date )
                    formData.append('paid_time', payment.paid_time )
                    formData.append('remark', payment.remark )
                    formData.append('is_remove_image', payment.is_remove_image ? payment.is_remove_image : false )
                    formData.append('payment_documentname', payment.payment_documentname ? payment.payment_documentname.join() : '' )

                    $.ajax({
                        type: "POST",
                        url: window.AJAX_URL,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        data: formData,
                        success: async (data) => {
                            if( data && data.success === true ){
                                alert('บันทึกข้อมูลสำเร็จ');
                                await this.fetchData()
                                this.syncBookingDetailData()
                                resolve({
                                    success: true
                                })
                            }else{
                                const errorMessage = data && data.message ? data.message : 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ'
                                alert(errorMessage);
                                resolve({
                                    success: false
                                })
                            }
                        },
                        error: (data) => {
                            alert('บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ');
                            resolve({
                                success: false
                            })
                        }
                    })
               })
            },
            handleCancelEditPayment(paymentId) {
                this.payments = this.payments.map( payment => {
                    if (payment.payment_paidbyid == paymentId) {
                        payment.isEdit = false
                    }
                    return payment;
                } )
            },
            doDeletePayin(paymentId) {

                const deletePayment = this.payments.find( payment => payment.payment_paidbyid == paymentId)

                $.post(window.AJAX_URL, {
                    dataType: 'json',
                    _wpnonce: AJAX_NONCE,
                    action: 'delete_payin',
                    pnrcode: this.bookingDetail.pnrcode,
                    paidbyid: deletePayment.payment_paidbyid,
                    payment_documentname: deletePayment.payment_documentname,
                })
                .done( data => {
                    this.syncBookingDetailData()
                })
            },
            onFormDataUpdate(fieldName, fieldValue, fieldGroupIndex){
                this.formData.passengers[fieldGroupIndex][fieldName] = fieldValue || '';
            },
            onSubmit(e){
                e.preventDefault();
                this.isSubmiting = true;
            },
            syncBookingDetailData() {
                $.get(window.AJAX_URL, {
                    dataType: 'json',
                    _wpnonce: AJAX_NONCE,
                    action: 'get_booking_detail',
                    pnrcode: this.bookingDetail.pnrcode,
                    email: this.bookingDetail.email_contact,
                })
                .done( data => {
                    if( data.success == true && data.booking_detail ){
                        this.bookingDetail = data.booking_detail
                    }
                })
                .fail( data => {
                });
            }
        }
    })
}